function sendAccessToken({ store }) {
  function onFulfilled(config) {
    const token = store.state.auth.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  }

  function onRejected(error) {
    return Promise.reject(error);
  }

  return [onFulfilled, onRejected];
}

export default sendAccessToken;
